module.exports = __webpack_public_path__ + "03_glasses_blue.df63ce27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/03_glasses_blue.png
// module id = YCtB
// module chunks = 0